import * as React from 'react'
import onClickOutside from 'react-onclickoutside'
import { Styled } from './styled'


export const VideoPopUp = onClickOutside(({ videoId, close }) => {
    VideoPopUp.handleClickOutside = () => close()
    const ration = 16 / 9
    const pageWidth = window.innerWidth
    const pageHeight = window.innerHeight
    const heightAdjust = pageWidth / pageHeight > ration
    const videoHeight = heightAdjust
      ? pageHeight * 0.8
      : (pageWidth * 0.8) / ration
    const videoWidth = heightAdjust ? pageHeight * 0.8 * ration : pageWidth * 0.8
    return videoId ? (
      <Styled.Container
        videoWidth={videoWidth}
        videoHeight={videoHeight}
        heightAdjust={heightAdjust}
      >
        <Styled.Shadow onClick={close} />
        <iframe
          title="YouTube Video "
          width={videoWidth}
          height={videoHeight}
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
          frameBorder="0"
          allow='autoplay'
          allowFullScreen={true}
        />
      </Styled.Container>
    ) : null
  }, { handleClickOutside: () => VideoPopUp.handleClickOutside }
)
